export function isMobile(): boolean {
	return window.matchMedia('(max-width: 30rem)').matches
}
